import { EVENT_IMAGES } from '../data/eventImages';

/**
 * Como o bucket agora é público, não precisamos mais assinar URLs!
 * Retornamos a própria publicUrl imediatamente para otimização de performance.
 */
export const getSignedUrlOnDemand = async (publicUrl) => {
  return publicUrl;
};

/**
 * Enriquece eventos que não possuem imagens com o catálogo de imagens curadas
 */
export const enrichEventWithImages = (event) => {
  if (!event) return event;
  const fotos = event.fotos || [];
  const hasPhotos = (Array.isArray(fotos) && fotos.length > 0) || Boolean(event.foto_url);

  if (!hasPhotos && EVENT_IMAGES[event.id]) {
    const fallback = EVENT_IMAGES[event.id];
    return {
      ...event,
      fotos: fallback.fotos,
      creditos_foto: event.creditos_foto || fallback.creditos_foto,
      image_status: (!event.image_status || event.image_status === 'Nao Editado' || event.image_status === 'Não Editado')
        ? 'Concluido'
        : event.image_status
    };
  }
  return event;
};

/**
 * Função para o Painel Admin (Events.jsx) e processamento de eventos
 */
export const processEventsForSignedUrls = async (events, supabase) => {
  return (events || []).map(enrichEventWithImages);
};
